<template>
  <div
    class="colorBall"
    style="height: 1em; width: 1em; margin-right: 3px; margin-top: -5px; cursor: pointer"
    v-bind:style="{ background: color || '#FFFFFF' }"
  />
</template>

<script>
export default {
  components: {},
  props: ["color"],
  data() {
    return {};
  },
  created() {},
};
</script>

<style scoped lang="scss"></style>
